export enum PropulsionType {
  Human = 'human',
  ElectricAssist = 'electricassist',
  Electric = 'electric',
  Combustion = 'combustion',
  Other = 'other',
}
